import React from 'react';
import {
  OnClick,
  OnPaymentAuthorized,
  OnPaymentAuthorizedInit,
  OnShippingContactSelected,
} from '../../types/ExternalContract';
import { Layout } from '../../types/Styles';
import { VerticalList } from './components/VerticalList';
import { HorizontalList } from './components/HorizontalList';

export interface Props {
  layout: Layout;
  horizontalLayoutHeaderClassName: string;
  horizontalLayoutDividerClassName: string;
  onClick: OnClick;
  availablePmsList: {
    googlePay: boolean;
    applePay: boolean;
    payPal: string[];
  };
  onShippingContactSelected: OnShippingContactSelected;
  onPaymentAuthorizedInit: OnPaymentAuthorizedInit;
  onPaymentAuthorized: OnPaymentAuthorized;
  isCollapsed: boolean;
  onMorePaymentOptionsClick(): void;
}

export const PaymentMethodsListView: React.FC<Props> = (props) => {
  const {
    layout,
    availablePmsList,
    isCollapsed,
    onMorePaymentOptionsClick,
    horizontalLayoutDividerClassName,
    horizontalLayoutHeaderClassName,
  } = props;

  const hasPms = availablePmsList.googlePay || availablePmsList.applePay || availablePmsList.payPal.length > 0;
  const isHorizontal = layout === 'horizontal';
  const isVertical = layout === 'vertical';

  if (!hasPms) {
    return null;
  }

  if (isHorizontal) {
    return (
      <HorizontalList
        availablePmsList={availablePmsList}
        horizontalLayoutDividerClassName={horizontalLayoutDividerClassName}
        horizontalLayoutHeaderClassName={horizontalLayoutHeaderClassName}
      ></HorizontalList>
    );
  }
  if (isVertical) {
    return (
      <VerticalList
        availablePmsList={availablePmsList}
        isCollapsed={isCollapsed}
        onMorePaymentOptionsClick={onMorePaymentOptionsClick}
      />
    );
  }

  return null;
};
